import(/* webpackMode: "eager", webpackExports: ["StructuredData"] */ "/app/components/common/StructuredData/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/SectionHome.tsx");
